import { render, staticRenderFns } from "./Likes.vue?vue&type=template&id=e45ad388&scoped=true"
import script from "./Likes.vue?vue&type=script&lang=js"
export * from "./Likes.vue?vue&type=script&lang=js"
import style0 from "./Likes.vue?vue&type=style&index=0&id=e45ad388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45ad388",
  null
  
)

export default component.exports